<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        @if(loaderIcon | async){
        <app-loader></app-loader>
        }
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>

        <div class="content-area">
            <div class="d-flex justify-content-between align-items-center mb-1">
                <h5 class="fw-semibold">Online Payment Settings</h5>
            </div>
            <hr />
            <div class="row">
                <div class="col-12 text-start mt-2">
                    <ul class="nav nav-tabs custom-tabs">
                        <li class="nav-item">
                            <button class="nav-link" [class.active]="disSettings" (click)="onTabChange('settings')">
                                Settings
                            </button>
                        </li>
                        <li class="nav-item">
                            <button class="nav-link" [class.active]="!disSettings"
                                (click)="onTabChange('terminalDevices')">
                                Terminal Devices
                            </button>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content">
                <div id="settings" *ngIf="disSettings">
                    <div class="p-3">
                        <form [formGroup]="PaymentSettingsForm">
                            <div class="container-fluid shadow p-3 mb-4 bg-white rounded">
                                <div class="mb-3">
                                    <h6 class="fw-bold">Online Payment Settings</h6>
                                </div>
                                <div class="mb-3">
                                    <label for="paymentGateway" class="form-label">Payment Gateway</label>
                                    <ejs-dropdownlist id='Category' [dataSource]='GateWayList' class="form"
                                        style="width: 340px;" formControlName="McsIntPaymentGateway"
                                        [fields]='DropDownfields' i18n-placeholder
                                        placeholder='Select Gateway'></ejs-dropdownlist>
                                    @if(PaymentSettingsForm.get('McsBitProcessCreditCardOnline').value == true &&
                                    PaymentSettingsForm.get('McsIntPaymentGateway').value == 0){
                                    <small style="color: red;" i18n>* required </small>
                                    }
                                </div>
                                <hr style="color: #E1E1E1;opacity: revert;" />
                                <div class="d-flex flex-wrap gap-4">
                                    <div class="form-check mb-3 mt-2">
                                        <input class="form-check-input" formControlName="McsBitProcessCreditCardOnline"
                                            type="checkbox" id="processCards">
                                        <label class="form-check-label" for="processCards">
                                            Process Credit Cards Online
                                        </label>
                                    </div>

                                    <div class="form-check mb-3 d-none">
                                        <input class="form-check-input" formControlName="EnableACH" type="checkbox"
                                            id="processCards1">
                                        <label class="form-check-label" for="processCards1">
                                            Enable ACH
                                        </label>
                                    </div>
                                </div>
                                <hr style="color: #E1E1E1;opacity: revert;" />

                                <div class="mb-3">
                                    <h6 class="fw-bold">Gateway Settings</h6>
                                </div>

                                <div class="row g-3"
                                    *ngIf="PaymentSettingsForm.get('McsIntPaymentGateway')?.value == EPaymentGateway.OpenEdgeExpress">
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label for="xwebId" class="form-label">XWeb ID</label>
                                            <input type="text" class="form-control" formControlName="XWEBID">
                                            @if(PaymentSettingsForm.get('XWEBID').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="mb-3">
                                            <label for="xwebAuthKey" class="form-label">XWeb Auth Key</label>
                                            <input type="text" class="form-control" formControlName="XWEBAUTHKEY">
                                            @if(PaymentSettingsForm.get('XWEBAUTHKEY').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="mb-3">
                                            <label for="cardNotPresentUrl" class="form-label">Card Not Present
                                                URL</label>
                                            <input type="text" class="form-control" formControlName="CardNotPresentURL">
                                            @if(PaymentSettingsForm.get('CardNotPresentURL').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="mb-3">
                                            <label for="apiIntegrationUrl" class="form-label">API Integration
                                                URL</label>
                                            <input type="text" class="form-control" formControlName="APIIntegrationURL">
                                            @if(PaymentSettingsForm.get('APIIntegrationURL').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="mb-3">
                                            <label for="xwebTerminalId" class="form-label">XWeb Terminal ID</label>
                                            <input type="text" class="form-control" formControlName="XWEBTERMINALID">
                                            @if(PaymentSettingsForm.get('XWEBTERMINALID').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="mb-3">
                                            <label for="rcmUrl" class="form-label">RCM URL</label>
                                            <input type="text" class="form-control" formControlName="RCMURL">
                                            @if(PaymentSettingsForm.get('RCMURL').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="mb-3">
                                            <label for="queryPaymentStatusUrl" class="form-label">Query Payment Status
                                                URL</label>
                                            <input type="text" class="form-control"
                                                formControlName="QueryPaymentStatusURL">
                                            @if(PaymentSettingsForm.get('QueryPaymentStatusURL').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div class="card border-0"
                                    *ngIf="PaymentSettingsForm.get('McsIntPaymentGateway')?.value == EPaymentGateway.Stripe">
                                    <div class="row g-4">
                                        <div class="col-md-6">
                                            <label class="form-label">Account ID</label>
                                            <input type="text" class="form-control" formControlName="AccountId">
                                            @if(PaymentSettingsForm.get('AccountId').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label">Publishable Key</label>
                                            <input type="text" class="form-control" formControlName="PublishableKey">
                                            @if(PaymentSettingsForm.get('PublishableKey').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label">Webhook Secret Key</label>
                                            <input type="text" class="form-control" formControlName="WebhookSecretKey">
                                            @if(PaymentSettingsForm.get('WebhookSecretKey').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label">Transfer Webhook Secret Key</label>
                                            <input type="text" class="form-control"
                                                formControlName="TransferWebhookSecretKey">
                                            @if(PaymentSettingsForm.get('TransferWebhookSecretKey').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label">Secret Key</label>
                                            <input type="text" class="form-control" formControlName="SecretKey">
                                            @if(PaymentSettingsForm.get('SecretKey').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label">Terminal IP / URL</label>
                                            <input type="text" class="form-control" formControlName="TerminalIpUrl">
                                            @if(PaymentSettingsForm.get('TerminalIpUrl').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label">Account Owner</label>
                                            <input type="text" class="form-control" formControlName="AccountOwner">
                                            @if(PaymentSettingsForm.get('AccountOwner').hasError('required')){
                                            <small style="color: red;" i18n>* required </small>
                                            }
                                        </div>
                                        <div class="col-md-6 d-flex align-items-center">
                                            <div class="form-check mt-3">
                                                <input id="mandatoryAddressField" class="form-check-input"
                                                    type="checkbox" formControlName="MandatoryAddressField">

                                                <label class="form-check-label" for="mandatoryAddressField">
                                                    Make Address Mandatory
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-end my-2">
                                    <button class="btn btnAS me-1" (click)="UpdatePaymentSettings($event)"
                                        [disabled]="DisablePaymentForm || !this.PaymentSettingsForm.dirty"
                                        i18n>Save</button>
                                    <button class="btn btn-orange" (click)="routeBack()">Cancel</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div *ngIf="!disSettings">
                    <div class="p-3">
                        <div class="row">
                            <div class="col-12 text-end">
                                <button class="btn btnAS" (click)="addTerminalDevice()">ADD</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 text-start mt-2">
                                <ejs-grid Height="300" cssClass="terminal-grid" [dataSource]="TerminalDevices"
                                    (rowSelected)="editTerminalDevice($event)" (rowSelecting)="onRowSelecting($event)">
                                    <e-columns>
                                        <e-column field="Devices" headerText="Device" width="150">
                                        </e-column>
                                        <e-column field="TerminalReaderId" headerText="Terminal Reader Id" width="120">
                                        </e-column>
                                        <e-column field="Primary" headerText="Primary" width="100" textAlign="Center">
                                            <ng-template #template let-data>
                                                <input type="checkbox" class="form-check-input m-0 readonly-checkbox"
                                                    [checked]="data.Primary" />
                                            </ng-template>
                                        </e-column>
                                        <e-column field="PaymentGatewayName" headerText="Payment Gateway" width="150">
                                        </e-column>
                                        <e-column field="Deleted" headerText="Delete" width="80" textAlign="Center">
                                            <ng-template #template let-data>
                                                <div class="delete-column" (click)="deleteTerminalDevice(data)">
                                                    <img src="../assets/images/Delete_Icon.svg"
                                                        class="img-fluid cursor-pointer" />
                                                </div>
                                            </ng-template>
                                        </e-column>
                                    </e-columns>
                                </ejs-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div #terminalDeviceModal class="modal fade" id="TerminalDevicesModal" tabindex="-1"
    aria-labelledby="TerminalDevicesModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <form [formGroup]="TerminalDeviceForm">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5">
                        {{ isEditMode ? 'Edit Terminal Device' : 'Add Terminal Device' }}
                    </h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6 col-lg-4 text-start mt-2">
                            <label>Device <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="Devices">
                            @if ((TerminalDeviceForm.get('Devices')?.hasError('required') ||
                            TerminalDeviceForm.get('Devices')?.hasError('whitespace')) &&
                            TerminalDeviceForm.get('Devices')?.touched) {
                            <small class="text-danger">
                                * Device is required
                            </small>
                            }
                        </div>
                        <div class="col-md-6 col-lg-4 text-start mt-2">
                            <label>Terminal Reader Id <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" formControlName="TerminalReaderId">
                            @if ((TerminalDeviceForm.get('TerminalReaderId')?.hasError('required') ||
                            TerminalDeviceForm.get('TerminalReaderId')?.hasError('whitespace')) &&
                            TerminalDeviceForm.get('TerminalReaderId')?.touched) {
                            <small class="text-danger">
                                * Terminal Reader Id is required
                            </small>
                            }
                        </div>
                        <div class="col-md-6 col-lg-4 text-start mt-2">
                            <div class="col-md-6 col-lg-4 mt-2 mt-md-4">
                                <div class="d-flex align-items-center">
                                    <input class="form-check-input position-static checkBoxClass mr-2" type="checkbox"
                                        id="chkPrimary" formControlName="Primary">
                                    <label class="mb-0 mt-1 ms-1" for="chkPrimary">Primary</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-4 text-start mt-3">
                            <label>Payment Gateway <span class="text-danger">*</span></label>
                            <ejs-dropdownlist #gatewayDropdown id='Category' [dataSource]='GateWayList'
                                formControlName="PaymentGatewayId" [fields]='DropDownfields' i18n-placeholder
                                [enabled]="false" placeholder='Select Gateway'></ejs-dropdownlist>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btnAS" (click)="saveTerminalDevice()">{{ isEditMode ? 'Update' :
                        'Save' }}</button>
                    <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </form>
    </div>
</div>